<template>
    <Detalhes 
        :titulo="'Foto'" 
        :labelIndicacao="'Clique na foto para adicionar marcações'"
        :exibirLoader="exibirLoader" 
        @aoSalvar="salvarFoto" 
        @aoSair="sairDetalhesFotos"
        class="relative"
    >
        <MarcacaoImagem 
            :imagem="imagem"
            :largura="larguraImagem"
            :altura="alturaImagem"
            :idImagemOrigem="'foto-origem'"
            :refComponente="'fotoMarcacao'"
            @ultimaImagem="tratarUltimaImagem"
        />
        
        <div class="absolute right-[3rem] bottom-[3rem] text-white">
            <span v-if="geolocalizacao?.geolocationStatus == 'OK'">{{ geolocalizacao.latitude }}, {{ geolocalizacao.longitude }}</span>
            <span class="ml-8">{{ (new Date(horario)).toLocaleString('pt-BR') }}</span>
        </div>
    </Detalhes>
</template>

<script>
import { computed, defineComponent, ref } from 'vue';
import ComponenteFotoService from '@/services/componentes/ComponenteFotoService';
import Detalhes from '@/components/Detalhes.vue';
import FuncoesHelper from '@/helpers/FuncoesHelper';
import ComponentesService from '@/services/ComponentesService';
import Actions from '@/store/Actions';
import MarcacaoImagem from '@/components/MarcacaoImagem.vue';

export default defineComponent({
    name: 'DetalheFoto',
    components: {
        Detalhes,
        MarcacaoImagem
    },
    methods: {
        tratarUltimaImagem(dados) {
            this.estadoUltimaMarcacao[dados.refComponente] = {
                ultimaMarcacao: dados.ultimaMarcacao,
                dataUrl: dados.dataUrl
            };
        },
        sairDetalhesFotos() {
            this.$router.push(`/${this.identificador}/${this.localRealizacao}/${this.modulo}/etapa/${this.etapaAtual}/${this.idComponente}/tirar-foto?tipo=${this.tipo}&id=${this.idImagem}`);
        },
        async salvarFoto() {
            this.exibirLoader = true;
            this.ignorarConfirmacao = true;

            const geolocalizacao = computed(() => this.$store.state.coordenadasTemp.localizacao);

            const localizacao = geolocalizacao.value || {};
            const coordenadas = localizacao.latitude ? `${localizacao.latitude}, ${localizacao.longitude}` : 'Localização indisponível';

            const idFoto = this.idImagem == '' || this.idImagem == 'Outras' ? FuncoesHelper.gerarUuid() : this.idImagem;

            const horario = ref(this.$store.state.fotosTemp.horario);
            const dataHora = (new Date(horario.value)).toLocaleString('pt-BR');

            let dataUrl = this.imagem;

            if (Object.prototype.hasOwnProperty.call(this.estadoUltimaMarcacao, 'fotoMarcacao') && this.estadoUltimaMarcacao.fotoMarcacao.dataUrl) {
                dataUrl = this.estadoUltimaMarcacao.fotoMarcacao.dataUrl;
            }

            dataUrl = await FuncoesHelper.mesclarImagemComMarcaDAgua(dataUrl, `${coordenadas}   ${dataHora}`);
            const { mimeType, byteSize } = FuncoesHelper.extrairMimetypeETamanhoImageData(dataUrl);

            const foto = {
                descricao: '',
                etapa: this.etapaAtual,
                idFoto,
                imagem: dataUrl,
                label: 'foto_' + this.tipo,
                tipo: 'FotosAvarias',
                metadados: {
                    size: byteSize,
                    type: mimeType,
                    ...geolocalizacao.value,
                    horario: horario.value
                }
            }

            const respostasComponente = {
                ...this.dadosComponentes.respostas,
                [idFoto]: foto
            }
            
            ComponentesService.salvarRespostaEstadoComponente(this.modulo, this.etapaAtual, this.idComponente, respostasComponente);
          
            this.$store.dispatch(Actions.SALVAR_FOTOS, {
                localRealizacao: this.localRealizacao,
                modulo: this.modulo,
                etapa: this.etapaAtual,
                idComponente: this.idComponente,
                foto
            });
        },
        confirmarSaida() {
            return this.$confirm("Deseja descartar a imagem?", "", "question", {
                cancelButtonText: "Não",
                confirmButtonText: "Sim",
            })
        }

    },
    setup() {

        return ComponenteFotoService.detalheFotoSetup()
    }
});
</script>